import React from 'react'
import UserForm from '../UserDetail/userForm'

const EditStudent = () => {
  return (
    <div>
      <UserForm/>
    </div>
  )
}

export default EditStudent
